import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  { q: "Is a French degree recognized in the U.S.?", a: "Yes. Most French public universities are internationally accredited, and degrees from recognized institutions are widely accepted by U.S. employers and graduate schools. We help you choose programs with strong international recognition." },
  { q: "Do I need to speak French?", a: "Not necessarily. A growing number of bachelor's and master's programs are taught fully in English, especially in business, engineering, and international studies. If you want to learn French along the way, that's a bonus, not a requirement." },
  { q: "Is it safe for my child to study alone in another country?", a: "France is a popular destination for international students, with established support systems for newcomers, student housing offices, health services, and international student associations. We also guide families through the visa, housing, and settling-in process step by step, so no one navigates it alone." },
  { q: "What about visas and paperwork?", a: "The student visa process is more straightforward than most people expect. We walk you through each step, from application to arrival." },
  { q: "Will my credits transfer if I want to come back to the U.S.?", a: "This depends on the specific program and university, and we help families understand transferability before committing, so there are no surprises." },
  { q: "How long does the whole process take?", a: "Most families start planning 6–12 months before enrollment. Our free quiz is the first step to seeing a personalized timeline." },
  { q: "What's the catch?", a: "No catch. France simply invests differently in higher education, keeping public tuition low for all students, including international ones." },
];

export default function FAQSection() {
  return (
    <section className="bg-[#f5f1e8] py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8">
          <span className="rule-gold" /><span className="eyebrow">Frequently asked</span>
        </div>
        <h2 className="serif text-5xl md:text-6xl leading-[0.98] tracking-tight text-[#0d1b3e] max-w-3xl">
          Answers to the questions <em className="italic text-[#b8892b]">parents ask most</em>.
        </h2>

        <div className="mt-14">
          <Accordion type="single" collapsible className="border-t border-[#0d1b3e]/15">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#0d1b3e]/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left serif text-xl md:text-2xl text-[#0d1b3e] py-6 hover:no-underline hover:text-[#b8892b] transition-colors">
                  <span className="flex items-baseline gap-4">
                    <span className="text-[#b8892b] text-sm font-semibold tracking-wider">{String(i + 1).padStart(2, "0")}</span>
                    <span>{item.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#4a5570] text-base leading-relaxed pb-8 pl-10 max-w-3xl">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <p className="text-[#0d1b3e]/70 text-base">Still have questions?</p>
          <Link
            to="/plan-builder"
            className="btn-sharp btn-sharp-primary inline-flex items-center gap-2"
            data-testid="faq-cta-free-match"
          >
            Get my free match <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
